import { AxiosResponse } from "axios";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetNotificationsReqData } from "./GetNotificationsReqData";

const ENDPOINT = "/notifications/download";

export class DownloadNotificationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetNotificationsReqData;

    constructor(exportType: string, payload: GetNotificationsReqData) {
        super();
        this.payload = payload;
        this.endPoint = this.endPoint + "/" + exportType;
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand(this.payload);
    }
}
